// @noflow
import React, { Component } from 'react';

/**
 * Takes a React Component and an interval for how often that Component should be updated.
 * Every interval the component will be rendered and have the current time passed when rendered.
 *
 * @param  {Component} WrappedComponent the Component to wrap
 * @param  {Number} interval         	the number of milliseconds per update
 * @return {[type]}                  [description]
 */
export default (WrappedComponent, interval) => {
    class IntervalUpdate extends Component {
        componentDidMount() {
            this._interval = setInterval(() => {
                this.forceUpdate();
            }, interval);
        }

        componentWillUnmount() {
            if (this._interval) {
                clearInterval(this._interval);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    // This is here because if it's a class property then shallow rendering won't see it
    const displayName = `intervalUpdate(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    IntervalUpdate.displayName = displayName;

    return IntervalUpdate;
};



// WEBPACK FOOTER //
// ./src/core/decorators/interval-update.js